import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "checkboxFocus",
  "use": "checkboxFocus-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" id=\"checkboxFocus\">\n    <rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" fill=\"none\" fill-rule=\"evenodd\" stroke=\"#007854\" rx=\"4\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/components/units/Icon/icons/checkboxFocus.svg
// module id = 507
// module chunks = 1